// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"warning-modal_inputContainer_2h4KE"};